const { cookie } = require('./mixins/cookie');
const CONSTANTS = require('./platform/constants').default;

let userData = {};

/*
allowchangedealer
carModelName
carModelYear
displayintransitinfo
displaymsrp
displayshortform
exteriorColorCode
interiorColorCode
exteriorColorIdent
interiorColorIdent
localDealerId
localDealerName
modelId
offerId
querySearch
source
userZipCode
*/

function getUrlParams(search) {
  const hashes = search.slice(search.indexOf('?') + 1).split('&');
  let params = {};
  let i;

  for (i = 0; i < hashes.length; i++) {
    const [key, val] = hashes[i].split('=');
    params[key.toLowerCase()] = decodeURIComponent(val);
  }

  if (search === '') {
    params = null;
  }

  return params;
}

function getUserParams() {
  // Retrieveing url parameters from window.raq.query provided on page render
  userData = {};
  let query = window.raq && window.raq.query ? window.raq.query : '';
  query = query.replace(/&amp;/g, '&');
  let urlParams = getUrlParams(query);
  userData.querySearch = query;
  // defaults
  userData.displayshortform = false;
  userData.displaymsrp = false;
  userData.displayintransitinfo = false;
  userData.allowchangedealer = true;

  // When on local test, url query string is used
  if (process.env.NODE_ENV === 'development') {
    urlParams = getUrlParams(window.location.search);
    userData.querySearch = window.location.search;
  }
  userData.urlParams = urlParams;

  // Origin related params:
  // source
  if (urlParams && urlParams.source) {
    userData.source = urlParams.source;
  }
  // displayshortform
  if (urlParams && urlParams.displayshortform) {
    userData.displayshortform = urlParams.displayshortform && parseInt(urlParams.displayshortform, 10) === 1;
  }
  // displaymsrp
  if (urlParams && urlParams.displaymsrp) {
    userData.displaymsrp = urlParams.displaymsrp && parseInt(urlParams.displaymsrp, 10) === 1;
  }
  // displayintransitinfo
  if (urlParams && urlParams.displayintransitinfo) {
    userData.displayintransitinfo = urlParams.displayintransitinfo && parseInt(urlParams.displayintransitinfo, 10) === 1;
  }
  // allowchangedealer
  if (urlParams && urlParams.allowchangedealer) {
    userData.allowchangedealer = parseInt(urlParams.allowchangedealer, 10) !== 0;
  }
  // offerId
  userData.offerId = urlParams && urlParams.offerid ? urlParams.offerid.split(',') : null;
  // Vehicle related params:
  // vehiclemodelseries
  if (urlParams && urlParams.vehiclemodelseries
      && urlParams.vehiclemodelseries.match(/^[a-zA-Z-]{1,}$/)) {
    userData.carModelName = urlParams.vehiclemodelseries;
  }
  // modelyear
  if (urlParams && urlParams.modelyear && urlParams.modelyear.match(/[0-9]{4}/)) {
    userData.carModelYear = urlParams.modelyear;
  }
  // modelId
  if (urlParams && urlParams.modelid) {
    userData.modelId = urlParams.modelid;
  }
  // exteriorColorCode
  if (urlParams && urlParams.exteriorcolorcode) {
    userData.exteriorColorCode = urlParams.exteriorcolorcode;
  }
  // interiorColorCode
  if (urlParams && urlParams.interiorcolorcode) {
    userData.interiorColorCode = urlParams.interiorcolorcode;
  }
  // exteriorColorIdent
  if (urlParams && urlParams.exteriorcolorident) {
    userData.exteriorColorIdent = urlParams.exteriorcolorident;
  }
  // interiorColorIdent
  if (urlParams && urlParams.interiorcolorident) {
    userData.interiorColorIdent = urlParams.interiorcolorident;
  }
  // extraData
  userData.extraData = '';
  if (urlParams && urlParams.extradata && urlParams.extradata !== 'undefined') {
    userData.extraData = urlParams.extradata;
  }
  // zipcode : this could also be a cookie
  // Used to create inventoryAndDealers & inventoryVehicleData requests
  if (urlParams && urlParams.zipcode && urlParams.zipcode.match(/^[0-9]+/)) {
    userData.userZipCode = urlParams.zipcode.substr(0, 5);
  } else {
    const zipCode = cookie.get(CONSTANTS.zipcodeCookieName);
    if (zipCode) {
      userData.userZipCode = zipCode.substr(0, 5);
    }
  }
  // dealerid : this could also be a cookie
  if (urlParams && urlParams.dealerid && urlParams.dealerid.match(/[0-9]+/)) {
    userData.localDealerId = urlParams.dealerid;
  } else {
    const preferredDealer = cookie.get(CONSTANTS.preferredDealerIdCookieName);
    if (preferredDealer) {
      userData.localDealerId = preferredDealer;
    }
  }
  return userData;
}

function setLocalDealer(dealerId, dealerName, dealerZip, address, phone) {
  userData.localDealerId = dealerId;
  userData.localDealerName = dealerName;
  userData.localDealerZip = dealerZip;
  userData.localDealerAddress = address;
  userData.localDealerPhone = phone;
}

function setVehicleName(name) {
  userData.carModelName = name;
}

function setVehicleModelMarketingName(marketingName) {
  userData.modelMarketingName = marketingName;
}

function setVehicleYear(year) {
  userData.carModelYear = year;
}

function getFallbackZipCode() {
  const zipCode = cookie.get(CONSTANTS.zipcodeCookieName);
  return zipCode || userData.localDealerZip;
}

function setVehicleColors(colors) {
  userData.exteriorColorName = colors.exterior && colors.exterior.Name
    ? colors.exterior.Name : null;
  userData.interiorColorName = colors.interior && colors.interior.Name
    ? colors.interior.Name : null;
}

function setVehicleModelId(modelId) {
  userData.modelId = modelId;
}

function setUndecidedPackage(data) {
  userData.undecidedPackage = data;
}

function setVehicle(data) {
  if (data && data.modelSeries && data.modelYear) {
    // Set selected vehicle modelseries name and year
    // Unset initial zipcode, modelid, exterior and interior colors
    userData.carModelName = data.modelSeries;
    userData.modelMarketingName = data.modelmarketingname;
    userData.carModelYear = data.modelYear;
    userData.modelId = data.modelId;
    userData.exteriorColorCode = null;
    userData.interiorColorCode = null;
  }
}

function unsetVehicle() {
  userData.carModelName = null;
  userData.modelMarketingName = null;
  userData.carModelYear = null;
  userData.modelId = null;
}

function getUserData() {
  return userData;
}

const params = {
  getParams: getUserParams,
  userData: getUserData,
  setUserVehicle: setVehicle,
  unsetVehicle,
  setLocalDealer,
  setVehicleColors,
  setVehicleName,
  setVehicleYear,
  setVehicleModelId,
  setUndecidedPackage,
  getFallbackZipCode,
  setVehicleModelMarketingName,
};

module.exports = params;
